import { IsIBAN, IsOptional, Length } from 'class-validator';

export class SellerCreateModel {
  @Length(2, 255)
  public name: string;

  @IsIBAN()
  public bankNumber: string;

  @IsOptional()
  @Length(10, 10)
  public taxNumber?: string;

  @Length(2, 255)
  public address: string;

  @Length(1, 6)
  public postalCode: string;

  @Length(1, 128)
  public city: string;

  @Length(1, 64)
  public country: string;

  constructor(
    name: string,
    bankNumber: string,
    taxNumber: string,
    address: string,
    postalCode: string,
    city: string,
    country: string,
  ) {
    this.name = name;
    this.bankNumber = bankNumber;
    this.taxNumber = taxNumber;
    this.address = address;
    this.postalCode = postalCode;
    this.city = city;
    this.country = country;
  }
}
